import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { toast } from 'react-toastify';

import { createBlock } from '~/api';

import { Button } from '~/components/_layouts/forms/styles';
import Dialog from '~/components/Dialog';
import {
  SDialogTitle,
  ActionButtonSection,
  defaultFieldProps,
} from '../../components/Dialog/styles';
import Loading from '~/components/Loading';

const FORM_INITIAL_VALUES = {
  name: null,
  series: null,
  reps: null,
};

export default function NewBlockDialog({
  isOpen,
  setIsOpen,
  workoutId,
  orderedIndex,
  refreshBlocks,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const workout = { id: workoutId };
      await createBlock({ ...values, workout, orderedIndex });
      toast.success('Bloco criado com sucesso !');

      refreshBlocks();
    } catch (error) {
      toast.error('Ops, não foi possivel criar novo bloco!');
    } finally {
      setIsLoading(false);
      setIsOpen(false);
    }
  };

  return (
    <Dialog open={isOpen}>
      <SDialogTitle>Novo Bloco</SDialogTitle>
      <Formik initialValues={FORM_INITIAL_VALUES} onSubmit={handleSubmit}>
        <Form>
          <div>
            <Field
              name="name"
              label="Nome do bloco"
              required
              {...defaultFieldProps}
            />
            <Field
              name="series"
              type="number"
              label="Séries"
              {...defaultFieldProps}
            />
            <Field
              name="reps"
              type="number"
              label="Repetições"
              {...defaultFieldProps}
            />
          </div>

          <ActionButtonSection>
            <Button
              disabled={isLoading}
              type="button"
              cancelButton
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </Button>
            <Button disabled={isLoading} type="submit">
              Criar
              {isLoading && <Loading buttonLoading />}
            </Button>
          </ActionButtonSection>
        </Form>
      </Formik>
    </Dialog>
  );
}

NewBlockDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  workoutId: PropTypes.number.isRequired,
  orderedIndex: PropTypes.number.isRequired,
  refreshBlocks: PropTypes.func.isRequired,
};
